var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_1199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.536 35.2973L28.0851 25.8464C30.6606 22.6965 31.9268 18.6772 31.622 14.6198C31.3171 10.5625 29.4645 6.77753 26.4472 4.04785C23.43 1.31816 19.479 -0.1474 15.4115 -0.0456992C11.344 0.0560011 7.47118 1.71718 4.59412 4.59424C1.71706 7.4713 0.0558791 11.3441 -0.0458213 15.4116C-0.147522 19.4791 1.31804 23.4301 4.04772 26.4474C6.77741 29.4646 10.5624 31.3173 14.6197 31.6221C18.677 31.927 22.6963 30.6607 25.8462 28.0852L35.2971 37.5361C35.5958 37.8245 35.9957 37.9841 36.4109 37.9805C36.826 37.9769 37.2231 37.8104 37.5167 37.5168C37.8103 37.2233 37.9768 36.8261 37.9804 36.411C37.984 35.9958 37.8244 35.5959 37.536 35.2973ZM15.8332 28.5C13.328 28.5 10.879 27.7571 8.79601 26.3653C6.71299 24.9735 5.08947 22.9952 4.13076 20.6807C3.17205 18.3661 2.92121 15.8193 3.40995 13.3622C3.8987 10.9051 5.10508 8.64813 6.87655 6.87667C8.64801 5.1052 10.905 3.89882 13.3621 3.41007C15.8192 2.92133 18.366 3.17217 20.6806 4.13088C22.9951 5.08959 24.9734 6.71311 26.3652 8.79613C27.757 10.8792 28.4999 13.3281 28.4999 15.8334C28.4961 19.1916 27.1604 22.4112 24.7858 24.7859C22.4111 27.1605 19.1915 28.4963 15.8332 28.5Z",
    fill: "#113C4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_1199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9be045f20a6021b7fd9f26775af7725e.svg";
export { ForwardRef as ReactComponent };